import { render, staticRenderFns } from "./InssTablePage.vue?vue&type=template&id=2579501a&"
import script from "./InssTablePage.vue?vue&type=script&lang=js&"
export * from "./InssTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports